import { render, staticRenderFns } from "./ImproveYourResultsTemplate.vue?vue&type=template&id=dc963c18&scoped=true"
import script from "./ImproveYourResultsTemplate.vue?vue&type=script&lang=js"
export * from "./ImproveYourResultsTemplate.vue?vue&type=script&lang=js"
import style0 from "./ImproveYourResultsTemplate.vue?vue&type=style&index=0&id=dc963c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc963c18",
  null
  
)

export default component.exports